<template>
    <div class="proposal-table px-3">
        <b-table-simple responsive bordered class="table-sm">
            <b-thead>
                <b-tr>
                    <b-th class="align-middle text-center">No.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 150px;">Bank Name</b-th>
                    <b-th class="align-middle text-center" style="min-width: 100px;">Facility</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Limit</b-th>
                    <b-th class="align-middle text-center" style="min-width: 110px;">Outstanding</b-th>
                    <b-th class="align-middle text-center" style="min-width: 130px;">Sett. Amount</b-th>
                    <!-- <b-th class="align-middle text-center" style="min-width: 130px;">Final Sett.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Sett. Date</b-th> -->
                    <b-th class="align-middle text-center" style="min-width: 170px;">Remark</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
                    <b-td>{{ index + 1 }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_bank_name || 'N/A' }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_loan_statue }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_credit_limit | moneyFormatter }}</b-td>
                    <b-td class="align-middle bg-grey">{{ item.pcom_current_outstanding | moneyFormatter }}</b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pcom_invinity_solution" @keydown="_gHlp.checkNonNumericInput" :disabled="!is_editable" size="mini"></b-form-input>
                    </b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pcom_remark" :disabled="!is_editable" size="mini"></b-form-input>
                    </b-td>
								</b-tr>
            </b-tbody>
            <b-tfoot>
                <b-tr class="font-weight-600">
                    <b-td colspan="3" class="text-right">
                        <p class="font-weight-600">Total</p>
                    </b-td>
                    <b-td class="text-center">{{ tableData.reduce((acc, invinity) => acc + (isNaN(parseFloat(invinity.pcom_credit_limit)) ? 0 : parseFloat(invinity.pcom_credit_limit)), 0) | moneyFormatter }}</b-td>
                    <b-td class="text-center">{{ tableData.reduce((acc, invinity) => acc + (isNaN(parseFloat(invinity.pcom_current_outstanding)) ? 0 : parseFloat(invinity.pcom_current_outstanding)), 0) | moneyFormatter }}</b-td>
                    <b-td>{{ tableData.reduce((acc, invinity) => acc + (isNaN(parseFloat(invinity.pcom_invinity_solution)) ? 0 : parseFloat(invinity.pcom_invinity_solution)), 0) | moneyFormatter }}</b-td>
                    <b-td>{{ tableData.reduce((acc, invinity) => acc + (isNaN(parseFloat(invinity.pcom_final_installment)) ? 0 : parseFloat(invinity.pcom_final_installment)), 0) | moneyFormatter }}</b-td>
										<b-td></b-td>
										<b-td></b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
        <div class="text-right" v-if="is_editable">
					<el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
        </div>
    </div>
</template>
<script>
import { Select, Option, DatePicker, Button } from 'element-ui'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
		props: ['psal_id','psal_invinity_id','is_editable'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Button.name]: Button,
    },
    data() {
        return {
            tableData: [],
            originalTableData: [],
            is_loading: false,
            is_updated:false,
        }
    },
    watch: {
			psal_id: {
				handler(newVal) {
					if(!_gHlp.isEmpty(newVal)){
						this.getListing(newVal)
					}
				},
				immediate: true,
			}
		},
    methods: {
				...mapActions(useInvinityStore, ['syncToLms']),
				...mapActions(useInitialProposalStore, ['updateProposalCommitment','getProposalCommitmentList']),
				getListing(psal_id){
					this.tableData = []
					this.originalTableData = []
					let params = {
						search:{
							pcom_psal_id: psal_id,
							pcom_kind: 'invinity'
						},
						paginate:'no_paginate'
					}
					this.getProposalCommitmentList(params).then(resp => {
						this.tableData = _gHlp.getValue(resp,'data',[]);
						this.originalTableData = cloneDeep(this.tableData);
					}).catch(e => {
						_gNotif.errorFunction(e)
					})
				},
        update(){
            var axiosCalls = []
            this.is_loading = true

            this.tableData.forEach((item) => {
                const original_item = this.originalTableData.find(o_item => o_item.pcom_id === item.pcom_id)
                if(original_item && !isEqual(original_item, item)){
										axiosCalls.push(this.updateProposalCommitment(item,item.pcom_id))
                }
            })

            Promise.all(axiosCalls)
                .then(res  => {
										_gNotif.notifySuccess('<b>Invinity Credit Settlements</b> - Successfully Updated.')
                    this.is_loading = false
                    if(axiosCalls.length > 0){
                        initialProposalEventBus.$emit('refresh-proposal-detail')
												if(!_gHlp.isEmpty(this.psal_invinity_id)){
													this.syncToLms(this.psal_id)
												}
                    }
                })
                .catch(e => {
                    this.is_loading = false
                    _gNotif.errorFunction(e)
                })
        }
    }
}
</script>